<div class="flex-container gap-6" style="height: 100%">
  <vl-widget-title
    [text]="'stats.quick_wins' | trans"
    [widget]="widget()"
    [draggable]="false"
    [editable]="false"
    [filter]="true"
  >
    <ng-content class="drag-handler" select=".drag-handler"></ng-content>

    <!-- Bouton filtre dans le header -->
    <ng-content class="filter" select=".filter">
      <vl-chips
        size="small"
        iconLeft="settings"
        (action)="trigger.attachOverlay()"
        [popoverTrigger]="filters"
        #trigger="popoverElement"
        [closeOnClickOutside]="true"
        state="enabled"
      >
        {{ 'button.filter' | trans }}
      </vl-chips>
    </ng-content>
  </vl-widget-title>

  <!-- Popover filtres -->
  <ng-template #filters>
    <div class="flex-col w100 gap-8 justup-card p-8 up-3">
      <div class="caption on-background">Options d'affichage</div>
      <div class="flex" style="gap:.75rem; align-items:center; flex-wrap:wrap">
        <div class="caption-2 on-background-alt">Top {{ topCount() }} / {{ maxRows() }}</div>
        <input type="range"
               [min]="1"
               [max]="Math.max(1, maxRows())"
               [value]="topCount()"
               (input)="topCount.set(($any($event.target).valueAsNumber)||1)"
               [disabled]="maxRows() <= 1"
               style="width:180px"
               aria-label="Limiter le nombre de références affichées"/>
        <div class="search-wrap" style="display:flex;align-items:center;gap:.4rem;">
          <span class="caption-2 on-background-alt">Filtrer :</span>
          <input type="search"
                 [value]="search()"
                 (input)="search.set(($any($event.target).value||'').toString())"
                 [placeholder]="'stats.reference_placeholder' | trans"
                 class="ju-input"
                 style="height:28px;padding:0 .5rem; min-width:220px"
                 aria-label="Filtrer par libellé article"/>
        </div>
      </div>

      <!-- Droite: tri + switch Graph/Liste -->
      <div class="flex" style="gap:.5rem; align-items:center; flex-wrap:wrap">
        <vl-chips-toggle [(value)]="sortBy" [elements]="elementsSort"></vl-chips-toggle>
        <vl-chips-toggle [(value)]="viewType" [elements]="elementsView"></vl-chips-toggle>
      </div>
    </div>
  </ng-template>

  @if (groups().length) {

    <!-- Graph -->
    <div class="canvas-wrap w100" [hidden]="viewType() === 'LIST'" style="height:360px;">
      <canvas #quickWin style="width:100%; height:100%; display:block;"></canvas>
    </div>

    <!-- Liste -->
    @if (viewType() === 'LIST') {
      <div class="list-box w100" style="width:100%; overflow-x:auto;">
        <div class="thead caption-2 on-background-alt" style="min-width:720px;">
          <div class="th">Référence</div>
          <div class="th right">Σ conso ({{ uniteDenomination() }})</div>
          <div class="th right">% pertes moy.</div>
          <div class="th right">Pertes ({{ uniteDenomination() }})</div>
          <div class="th right">Pertes (€)</div>
          <div class="th right">OFs</div>
        </div>

        @for (r of topRows(); track r.ref) {
          <div class="row border-bottom-outline-opacity-50 table-row" style="min-width:720px;">
            <div class="td on-background" [title]="labelFor(r.ref)">{{ labelFor(r.ref) }}</div>
            <div class="td right on-background">{{ r.totalConso | numberSig }}</div>
            <div class="td right on-background">{{ fmtPct(r.lossPct) }}</div>
            <div class="td right on-warning">{{ r.lossAbsKg | numberSig }}</div>
            <div class="td right on-background">{{ r.lossEur | numberSig }} €</div>
            <div class="td right on-background">{{ r.n }}</div>
          </div>
        }

        @if (topRows().length === 0) {
          <div class="empty">Aucune référence avec ces filtres.</div>
        }
      </div>
    }

    <footer class="page-footer caption on-background-alt">
      Astuce : cliquez une bulle pour voir les OF concernés. (bulles = pertes en {{ uniteDenomination() }} —
      Top {{ topCount() }})
    </footer>
  } @else {
    <div class="widget-content empty">
      <div class="caption on-disabled">{{ 'filters.no_data' | trans }}</div>
    </div>
  }

</div>

@if (selectedOfs().length) {
  <div class="justup-card-reverse container-background border-outline up-3">
    <div class="w100 flex-row align-center justify-between">
      <div class="title on-background">OFs pour <strong>{{ selectedLabel() }}</strong></div>
      <vl-chips state="warn" iconRight="clear" (action)="clearSelection()">{{ 'button.reset' | trans }}</vl-chips>
    </div>

    <div class="table">
      <div class="thead caption-2 on-background-alt">
        <div>OF</div>
        <div class="right">Conso</div>
        <div class="right">Théorique</div>
        <div class="right">Perte ({{ uniteDenomination() }})</div>
        <div class="right">Perte (%/€)</div>
      </div>

      @for (ofr of selectedOfs(); track $index) {
        <div class="row border-bottom-outline-opacity-50 table-row">
          <div class="on-background">
            <vl-of-card
              [currentOf]="ofr.of"
              [simpleWithDate]="true"
              [actions]="true"
              (action)="goOf.emit()"
              route="productions/suivi/stats"
            />
          </div>
          <div class="right on-background">{{ ofr.consoProd | numberSig }} {{ uniteDenomination() }}</div>
          <div class="right on-background">{{ ofr.consoTheorique | numberSig }} {{ uniteDenomination() }}</div>
          <div class="right on-warning">{{ ofr.pertesAbsKg | numberSig }} {{ uniteDenomination() }}</div>
          <div class="right on-background">
            <vl-percent
              [percent]="ofr.pertesPct"
              [typePercent]="TypePercent.OF_MATIERE"
              [fixed]="2"
              [valeur]="ofr.pertesEur"
            ></vl-percent>
          </div>
        </div>
      }
    </div>
  </div>
}
